/**
 * ActionBar Component
 * Displays save/discard action bar when there are unsaved changes
 */

import React from 'react';

const ActionBar = ({ 
  unsavedChangesCount, 
  onDiscard, 
  onSave, 
  saving 
}) => {
  if (unsavedChangesCount === 0) {
    return null;
  }

  return (
    <div className="rp-action-bar">
      {/* Unsaved changes indicator */}
      <div className="unsaved-indicator">
        <i className="bi bi-exclamation-triangle"></i>
        {unsavedChangesCount} unsaved change{unsavedChangesCount !== 1 ? 's' : ''}
      </div>
      
      {/* Action buttons */}
      <div className="action-buttons">
        <button 
          className="discard-btn"
          onClick={onDiscard}
          disabled={saving}
        >
          <i className="bi bi-x-lg"></i>
          Discard
        </button>
        
        <button 
          className="save-btn"
          onClick={onSave}
          disabled={saving}
        >
          {saving ? (
            <>
              <i className="bi bi-arrow-repeat spin"></i>
              Saving...
            </>
          ) : (
            <>
              <i className="bi bi-floppy"></i>
              Save Changes
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ActionBar;

